import { render } from "./basic-hover-information.vue?vue&type=template&id=6f04edc0"
import script from "./basic-hover-information.vue?vue&type=script&lang=js"
export * from "./basic-hover-information.vue?vue&type=script&lang=js"

import "./basic-hover-information.vue?vue&type=style&index=0&id=6f04edc0&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__